<template>
  <v-flex :[dinamicFlexSmall]="true" :[dinamicFlexMedium]="true">
    <v-text-field
      :label="label"
      @click='onPickFile'
      v-model='fileName'
      prepend-icon="attach_file"
      :rules="rules"
    ></v-text-field>
    <!-- Hidden -->
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      accept="image/*"
      :id="idInput"
      @change="onFilePicked">
    <div :id="idProgress" :style="styleProgress">
      <strong>{{ textProgress }}</strong>
      <v-progress-linear :color="colorProgress" height="10" :indeterminate="true">
      </v-progress-linear>
    </div>
    <img :id="idImg" :src="this.baseImg" ref="snapshotImg" :rules="rules" style="width: 100%">
    <canvas id="snapshot" ref="snapshot" style="display: none"></canvas>
  </v-flex>
</template>

<script>
export default {
  name: 'foto_subir',
  data: () => ({
    baseImg: 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
    loading: false,
    fileName: '',
    fileObject: '',
    url: '',
  }),
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/no-dupe-keys
    size: {
      type: String,
      required: false,
      default: '3',
    },
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    idImg: {
      type: String,
      required: true,
    },
    idInput: {
      type: String,
      required: false,
    },
    idProgress: {
      type: String,
      required: false,
    },
    textProgress: {
      type: String,
      required: false,
    },
    colorProgress: {
      type: String,
      required: false,
    },
    styleProgress: {
      type: String,
      required: false,
      default: 'display: none',
    },
    rules: {
      type: Array,
      required: false,
    },
  },
  watch: {

  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const { files } = event.target;
      if (files[0] !== undefined) {
        this.fileName = files[0].name;
        const imageToShow = document.getElementById(this.idImg);
        imageToShow.src = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return;
        }
        // If valid, continue
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.$emit('input', fr.result);
          if (this.idImg !== 'imgRostro') {
            this.url = fr.result;
            // eslint-disable-next-line prefer-destructuring
            this.fileObject = files[0];
            this.baseImg = this.url;
          }
        });
      } else {
        this.fileName = '';
        this.fileObject = null;
        this.url = '';
      }
    },
  },
  computed: {
    dinamicFlexSmall() {
      return 'sm'.concat(this.size);
    },
    dinamicFlexMedium() {
      return 'md'.concat(this.size);
    },
  },
};
</script>

<style scoped>

</style>
